import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { KeeniconComponent } from '../../partials';
import { NgTemplateOutlet } from '@angular/common';
import { ValidationFormComponent } from '../validation-form/validation-form.component';
import { AutoHttpsDirective } from '@core-utils';

@Component({
  selector: 'ui-form-icon-input',
  imports: [
    ReactiveFormsModule,
    KeeniconComponent,
    NgTemplateOutlet,
    ValidationFormComponent,
    AutoHttpsDirective,
  ],
  templateUrl: './form-icon-input.component.html',
  styleUrl: './form-icon-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class FormIconInputComponent {
  dataCy = input<string>('');
  control = input<AbstractControl>();
  icon = input<string>('');
  image = input<string>('');
  description = input<string>('');
  skipValidation = input<boolean>(false);
  placeholder = input<string>('');
  enableAutoHttps = input<boolean>(false);

  get formControl(): FormControl {
    return this.control() as FormControl;
  }
}
